import { CommitableSlidePanel } from "@/components/slide-panel";
import { Component, Mixins, Prop } from "vue-property-decorator";
import Uploader from '@/components/uploader';
import { uploadShp } from '@/lib/services';
import Progress from '@/components/progress';
import { Action } from 'vuex-class';
import { loadingClass } from '@/lib/helpers';

@Component
export default class PanelAddContour extends Mixins(CommitableSlidePanel) {

  @Prop({type: Boolean, default: false}) readonly isCus: boolean;

  @Action notify;

  protected isUploading: boolean = false;
  protected uploadProgress: {value: number; total: number} = null;

  get rootClasses() {
    return ["panel-add-contour"];
  }

  get isCommitable() {
    return false;
  }

  onClickCancel() {
    this.cancel();
  }

  onUploadStart() {
    this.isUploading = true;
  }
  
  onUploadEnd(e) {
    if (e.errors && e.errors.length) {
      this.notify({
        message: <ul>{e.errors.map(e => <li>{e}</li>)}</ul>,
        level: "danger"
      });
    } else {
      this.commit({data: e.fileInfo.file});
    }
    this.isUploading = false;
  }

  onUploadError(_) {
    this.notify({
      message: <ul><li>Une erreur technique est survenue</li></ul>,
      level: "danger"
    });
    this.isUploading = false;
    setTimeout(() => {
      this.cancel();
    }, 1000);
  }

  onUploadProgress(value) {
    this.uploadProgress = value;
  }

  mounted() {}

  renderHead() {
    return <span>Ajouter un contour</span>
  }

  renderBody() {
    return (
      <div class="basic">
        <div class="columns">
          <div class="column is-half">
            <img src={require('../../../../public/assets/images/illu_shp.png')} class="illu-shp"/>
          </div>
          <div class="column is-half is-flex align-items-center">
            Veuillez compresser vos fichiers shapefile (.shp, .dbf et associés) dans une archive .zip avant de les envoyer.
          </div>
        </div>
        {this.isUploading && this.uploadProgress != null && (
          <div class="columns">
            <Progress progress={this.uploadProgress.value} total={this.uploadProgress.total}/>
          </div>
        )}
      </div>
    );
  }

  renderFooter() {
    return (
      <div class="columns is-fluid">
        <div class="column is-7"></div>
        <div class="column is-5 is-flex justify-end">
          <button class="button is-small is-fluid" onClick={this.onClickCancel}>Annuler</button>
          <Uploader
            class="is-inline"
            service={ body => uploadShp(body, this.isCus) }
            onUploadStart={this.onUploadStart}
            onUploadEnd={this.onUploadEnd}
            onUploadProgress={this.onUploadProgress}
            onUploadError={this.onUploadError}
            value={null}
            withProgress={false}
            preview={false}
          >
            <button class={`button is-primary is-small is-fluid ${loadingClass(this.isUploading)}`} disabled={this.isUploading}>+ Monter le contour</button>
          </Uploader>
        </div>
      </div>
    )
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4ea7d719/panel-add-contour.tsx" });